// src/screens/payment/PaymentResult.jsx

import React from 'react';
import './PaymentResult.css';

const PaymentResult = () => {
  return (
    <div className="payment-result-container">
      <div className="payment-result-card">
        <div className="icon-processing">⏳</div>
        <h1>Ödəniş Nəticəsi Yoxlanılır</h1>
        <p>Ödəniş məlumatlarınız server tərəfindən emal olunur. Zəhmət olmasa, bir az gözləyin və ya sonradan yenidən yoxlayın.</p>
      </div>
    </div>
  );
};

export default PaymentResult;
